/* eslint-disable import/first */
import { setPublicPath } from 'systemjs-webpack-interop';
setPublicPath('PERMISSION_UX', 3);

import React from 'react';
import ReactDOM from 'react-dom';
import SingleSpaReact from 'single-spa-react';

import '@optimizely/axiom/dist/styles.css';
import rootComponent from './app';

// rootComponent is imported statically above to remove extra chunk (App.chunk.js) from being created
const loadRootComponent = () => Promise.resolve(rootComponent);

const reactLifecycles = SingleSpaReact({
  loadRootComponent,
  React,
  ReactDOM,
  renderType: 'render',
});

export const bootstrap = reactLifecycles.bootstrap;
export const mount = reactLifecycles.mount;
export const unmount = reactLifecycles.unmount;

const PermissionUxApplication = {
  bootstrap,
  mount,
  unmount,
};

export default PermissionUxApplication;
